export default __webpack_public_path__ + "assets/marker.dfe41cf5.svg";